import "./CustomerSupportContent.scss";

import { FC } from "react";

import { TextLink } from "components/Buttons";
import Text from "components/Text/Text";
import VariableText from "components/VariableText/VariableText";
import { ClassName, SpacerFormItem } from "config";
import { useModal, useTranslation } from "modules";

import classNames from "classnames";

interface IProps {
  className?: ClassName;
  dataTestId?: string;
  spacer?: SpacerFormItem["content"]["min"];
}

export const CustomerSupportContent: FC<IProps> = ({
  className,
  dataTestId,
  spacer = "space8",
}) => {
  const openModal = useModal();
  const { t } = useTranslation();

  const handleSupportClick = () => {
    openModal("CustomerSupportModal");
  };

  const chatButton = (
    <TextLink
      onClick={handleSupportClick}
      className="customer-support-content__cta"
      text={t("customer_support_content.chat.cta", "Chat with us")}
    />
  );

  const supportTitle = (
    <VariableText
      text={t(
        "customer_support_content.chat.header",
        "Have questions? <button>Chat with us</button>"
      )}
      target={/(?:<button.*?>|<\/button>)/g}
      replacementValue={chatButton}
    />
  );

  const classes = classNames(className, "customer-support-content__container", "text-center");

  return (
    <div className={classes} data-testid={dataTestId}>
      <Text tag="l5-label">{supportTitle}</Text>
      <div className={`mb-${spacer}`} />
      <Text
        tag="b5"
        text={t(
          "customer_support_content.chat.body",
          "Live chat support is available Monday-Friday during business hours (9am-5pm EST)."
        )}
      />
    </div>
  );
};

export default CustomerSupportContent;
